import * as datastore from '@/datastore'

export interface Category_List extends datastore.Reference {
	categoryId: string
	listId: string
}

export const defaultCategory_List: Readonly<Category_List> = {
	$id: '',
	categoryId: '',
	listId: '',
}
